import { convertDurationToTime } from '@repo/ui/src/functions/video-functions';
import YoutubePlay from '@repo/ui/src/components/Icons/YoutubePlayIcon';

interface Props {
  title?: string;
  duration?: string | number;
  imgUrl?: string;
  onClick?: () => void;
}

const VideoThumbnail = ({ imgUrl, title, duration, onClick }: Props) => (
  <button
    className="relative w-full tra-btn-bare"
    onClick={onClick}
    aria-label={`Play ${title} video`}
  >
    {imgUrl && <img src={imgUrl} alt="" className="w-full aspect-video object-cover" />}
    {duration && (
      <span className="absolute bottom-3 right-3 px-2 bg-neutral-600 rounded text-white">
        <span className="sr-only">Video Duration: </span>
        {convertDurationToTime(Number(duration))}
      </span>
    )}
    {imgUrl && (
      <div className="absolute w-[75px] h-[75px] translate-x-[-50%] translate-y-[-50%] left-1/2 top-1/2">
        <YoutubePlay color="#fff" height="auto" uniqueId={title} shadow />
      </div>
    )}
  </button>
);

export default VideoThumbnail;
